import { Star } from "lucide-react";

export const Stars = ({ value, size = "w-4 h-4", testid }) => (
  <span data-testid={testid} className="inline-flex gap-0.5" aria-label={`${value} sur 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= Math.round(value) ? "text-amber-400 fill-amber-400" : "text-slate-300"}`} />
    ))}
  </span>
);

export const StarPicker = ({ value, onChange }) => (
  <div data-testid="review-rating-picker" className="flex gap-1" role="radiogroup">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" role="radio" aria-checked={value === n} aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
        data-testid={`review-star-${n}`} onClick={() => onChange(n)} className="p-1 transition-transform hover:scale-110">
        <Star className={`w-9 h-9 ${n <= value ? "text-amber-400 fill-amber-400" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);
